/**
 * Constants for Aggregated Clients API Integration
 */

export const AGGREGATED_CLIENTS_CONSTANTS = {
    API: {
        ENDPOINT_BASE: '/api/aggregated/v1/users',
        getClientsEndpoint: (userId: string): string =>
            `${AGGREGATED_CLIENTS_CONSTANTS.API.ENDPOINT_BASE}/${userId}/clients`,
    },
    QUERY_PARAMS: {
        PAGE: 'page',
        LIMIT: 'limit',
        ORGANISATION_CODES: 'organisation_codes',
        SEARCH: 'search',
        VIEW: 'view',
    },
    PAGINATION: {
        DEFAULT_PAGE: 1,
        DEFAULT_LIMIT: 10,
    },
    ERROR_MESSAGES: {
        USER_ID_NOT_AVAILABLE: 'User ID not available',
        CLIENT_NOT_FOUND: 'Client not found',
        ACCESS_DENIED: 'Access denied',
        MISSING_ORGANISATION_DETAILS: 'Missing organisation details in client data',
    },
    ADDRESS_TYPES: {
        SHIPPING: 'shipping',
        BILLING: 'billing',
        BOTH: 'both',
    },
    REQUEST_STATUS: {
        PENDING: 'PENDING',
        APPROVE: 'APPROVE',
        APPROVED: 'APPROVED',
        REJECT: 'REJECT',
        REJECTED: 'REJECTED',
    },
} as const

export const ADDRESS_TYPE_VALUES = [
    AGGREGATED_CLIENTS_CONSTANTS.ADDRESS_TYPES.SHIPPING,
    AGGREGATED_CLIENTS_CONSTANTS.ADDRESS_TYPES.BILLING,
    AGGREGATED_CLIENTS_CONSTANTS.ADDRESS_TYPES.BOTH,
] as const
